export default __webpack_public_path__ + "static/media/recycle_spinner.2556a37b.gif";